module.exports = __webpack_public_path__ + "static/media/02.d0845187.png";